package pl.mothdigital.neuronowi.components.sections.team

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.forms.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.varabyte.kobweb.silk.components.navigation.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.common.utils.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.components.layouts.*
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.navigation.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

@Composable
fun TeamSection(ctx: PageContext) {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .standardSectionPadding()
            .toAttrs()
    ) {
        ImageTextFlexLayout(
            image = ImageResources.teamSectionImage,
            imageBorderRadius = 1.cssRem,
            title = {
                AppH2 { Text(StringResources.TEAM_SECTION_TITLE) }
            },
            desc = {
                Column(
                    modifier = Modifier.gap(1.5.cssRem)
                ) {
                    AppP {
                        Text(StringResources.TEAM_SECTION_DESC_1.fixPolishOrphans())
                    }

                    AppP {
                        Text(StringResources.TEAM_SECTION_DESC_2.fixPolishOrphans())
                    }

                    AppP(color = SiteTheme.green._800) {
                        Text(StringResources.TEAM_SECTION_DESC_3.fixPolishOrphans())
                    }

                    Link(
                        path = Screen.Specialists.route,
                        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
                        modifier = Modifier.textDecorationLine(TextDecorationLine.None)
                    ) {
                        Button(
                            onClick = {},
                            modifier = Modifier.padding(8.px),
                            type = ButtonType.Button,
                            colorPalette = SiteTheme.green,
                        ) {
                            SpanText(
                                text = StringResources.TEAM_SECTION_BUTTON,
                                modifier = TextBaseStyle.toModifier()
                                    .color(SiteTheme.white._900)
                                    .fontWeight(FontWeight.Normal)
                            )
                        }
                    }
                }
            }
        )
    }
}
